import ProductCardEx from './ProductCardEx';

export default ProductCardEx;
